import { useTranslation } from "react-i18next";
import { Loader2 } from "lucide-react";

import { Alert, AlertTitle } from "@/components/ui/alert";

export interface DgiConfirmationPendingAlertProps {
  visible: boolean;
}

export function DgiConfirmationPendingAlert({
  visible,
}: DgiConfirmationPendingAlertProps): JSX.Element | null {
  const { t } = useTranslation();

  if (!visible) return null;

  return (
    <Alert variant="info" className="flex items-start gap-3">
      <Loader2
        className="h-4 w-4 shrink-0 animate-spin text-blue-600 dark:text-blue-400"
        aria-hidden
      />
      <div className="flex flex-col gap-0.5">
        <AlertTitle className="mb-0">
          {t("onboarding.dgiConfirmationPendingTitle")}
        </AlertTitle>
      </div>
    </Alert>
  );
}
